// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"ed22286a","845":"cef695ac"}[chunkId] + ".chunk.js";
};